import React from "react";
import LegalPage from "@/pages/legal/LegalPage";
import { GRIEVANCE, GRIEVANCE_OFFICER, BUSINESS } from "@/pages/legal/_content";
import { RenderText } from "@/components/Footer";
import { Mail, Phone, MapPin, Clock } from "lucide-react";

const Grievance = () => (
  <LegalPage doc={GRIEVANCE}>
    <section>
      <h2 className="font-display text-lg font-bold text-slate-900 mb-2">1. How to file a complaint</h2>
      <p>
        If you have a complaint about how CarryIt has handled your parcel, your
        account, your personal information, or the behaviour of another user,
        please write to the Grievance Officer. Include your CarryIt user ID,
        the delivery ID (if applicable), and clear details of the issue with
        any supporting evidence.
      </p>
    </section>

    <section>
      <h2 className="font-display text-lg font-bold text-slate-900 mb-3">2. Grievance Officer</h2>
      <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5 space-y-2 text-sm">
        <div className="flex items-center gap-2"><span className="text-slate-500 w-28">Name</span><span className="font-medium"><RenderText text={GRIEVANCE_OFFICER.name}/></span></div>
        <div className="flex items-center gap-2"><span className="text-slate-500 w-28">Designation</span><span className="font-medium"><RenderText text={GRIEVANCE_OFFICER.designation}/></span></div>
        <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-slate-500"/><span className="text-slate-500 w-24">Email</span><span className="font-mono"><RenderText text={GRIEVANCE_OFFICER.email}/></span></div>
        <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-slate-500"/><span className="text-slate-500 w-24">Phone</span><span className="font-mono"><RenderText text={GRIEVANCE_OFFICER.phone}/></span></div>
        <div className="flex items-start gap-2"><MapPin className="w-4 h-4 text-slate-500 mt-0.5"/><span className="text-slate-500 w-24">Address</span><span><RenderText text={GRIEVANCE_OFFICER.address}/></span></div>
      </div>
    </section>

    <section>
      <h2 className="font-display text-lg font-bold text-slate-900 mb-2">3. Timelines</h2>
      <ul className="space-y-2">
        <li className="flex items-start gap-2"><Clock className="w-4 h-4 text-slate-500 mt-0.5"/><span><b>Within 48 hours</b> of receipt, the Grievance Officer will acknowledge your complaint in writing (email).</span></li>
        <li className="flex items-start gap-2"><Clock className="w-4 h-4 text-slate-500 mt-0.5"/><span><b>Within 30 days</b> of receipt, the Grievance Officer will resolve the complaint. If more time is needed, we will explain why and share a revised timeline.</span></li>
      </ul>
    </section>

    <section>
      <h2 className="font-display text-lg font-bold text-slate-900 mb-2">4. Escalation</h2>
      <p>
        If you are not satisfied with the Grievance Officer's resolution, you
        may escalate the matter to the CarryIt leadership team by writing to{" "}
        <RenderText text={BUSINESS.email}/>. If the matter concerns your
        personal information, you may also approach the appropriate
        data-protection authority under Indian law.
      </p>
    </section>

    <section>
      <h2 className="font-display text-lg font-bold text-slate-900 mb-2">5. Bad-faith complaints</h2>
      <p>
        We take every complaint seriously. Repeated complaints that we
        reasonably determine to be vexatious or made in bad faith may result in
        account suspension.
      </p>
    </section>
  </LegalPage>
);

export default Grievance;
